import React from 'react'
import { AtSymbol, Document, Download, Folder } from '~/components/icons'
import { Node } from '~/types'

export interface RecipeOutputNodeProps extends Node.Props {
  type: 'tasks' | 'folder' | 'parameter'
}

export const RecipeOutputNode: React.FunctionComponent<RecipeOutputNodeProps> = ({
  position,
  label,
  live = false,
  type,
}) => {
  const [x, y] = position

  const icon = () => {
    const iconProps = { filled: true, mode: 'dark' as 'dark' | 'light' }
    switch (type) {
      case 'tasks':
        return <Document {...iconProps} />
      case 'folder':
        return <Folder {...iconProps} />
      case 'parameter':
        return <AtSymbol {...iconProps} />
    }
  }

  return (
    <g transform={`translate(${x + 4}, ${y})`}>
      <g transform="translate(-13, -13)">
        <g className="output-node">
          <circle cx={13} cy={13} r={17} stroke="#333" strokeWidth="2px" fill="#FFF" />
          <polyline
            points="13,-4 30,-4 30,13"
            stroke="#333"
            strokeWidth="2px"
            fill="#FFF"
            transform="rotate(-135, 13, 13)"
          />
          <g className={`output-node-icon ${live ? 'output-node-icon--live' : ''}`}>{icon()}</g>
          <g className={`output-node-download-icon ${live ? 'output-node-download-icon--live' : ''}`}>
            <Download mode="dark" />
          </g>
          <g transform={'translate(37, 16)'}>
            <text className="recipe-output-node-label" textAnchor="left" fontSize={12}>
              <tspan>{label.length > 20 ? `${label.substr(0, 18)}...` : label}</tspan>
            </text>
          </g>
        </g>
      </g>
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');

        .output-node {
          cursor: pointer;
        }

        .output-node-icon {
          opacity: 1;
          transform: translate(7px, 7px);
          transition: 300ms;
          transition-timing-function: ease;
        }

        .output-node-download-icon {
          opacity: 0;
          transform: translate(7px, -5px);
          transition: 300ms;
          transition-timing-function: ease;
        }

        .output-node:hover > .output-node-icon--live {
          opacity: 0;
          transform: translate(7px, 19px);
        }

        .output-node:hover > .output-node-download-icon--live {
          opacity: 1;
          transform: translate(7px, 7px);
        }

        .recipe-output-node-label {
          font-family: 'Inter', sans-serif;
          font-size: 12px;
          font-weight: 400;
          fill: #333;
        }
      `}</style>
    </g>
  )
}

export default RecipeOutputNode
